<h1 mat-dialog-title>Alert</h1>
<mat-dialog-content>Current Type will be used if all attributes are selected</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button [mat-dialog-close]="true" cdkFocusInitial>Confirm</button>
</mat-dialog-actions>
